<!-- eslint-disable import/no-cycle -->
<template>
  <section id="dashboard-analytics">
    <!-- alert -->
    <b-alert
      v-model="showDismissibleAlert"
      v-height-fade.appear
      variant="danger"
      dismissible
      class="mb-0"
    >
      <div class="alert-body">
        Você precisa selecionar todos os campos!
      </div>
    </b-alert>

    <b-row class="match-height">
      <!-- range -->
      <b-col md="4">
        <b-form-group>
          <h5>Período</h5>
          <flat-pickr
            v-model="rangeDate"
            class="form-control"
            :config="{ mode: 'range'}"
            placeholder="período da busca"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <h5>Loja</h5>
          <v-select
            v-model="store"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="name"
            :options="stores"
            placeholder="Selecione"
          />
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <h5>Atendente</h5>
          <v-select
            v-model="attendent"
            label="name"
            :options="attendents"
            placeholder="Selecione"
          />
        </b-form-group>
      </b-col>
      <!-- <b-col md="3">
        <b-form-group>
          <h5>Contato</h5>
          <v-select
            v-model="searchtype"
            label="name"
            :options="searchtypes"
            placeholder="Selecione"
          />
        </b-form-group>
      </b-col> -->
    </b-row>
    <b-button
      id="getReport"
      type="reset"
      variant="outline-secondary"
      @click="getReport()"
    >
      Gerar Relatório

    </b-button>
    <br><br>
    <b-row class="match-height">
      <b-col
        lg="6"
        md="12"
      >
        <analytics-congratulation
          v-if="congratulations.name"
          :data="congratulations"
        />
      </b-col>
      <b-col
        lg="3"
        sm="6"
      >
        <statistic-card-with-area-chart
          v-if="data.subscribersGained"
          icon="UsersIcon"
          :statistic="kFormatter(cardConvertidos.analyticsData.convertidos)"
          :statistic-title="cardConvertidos.analyticsData.contactados + ' contactados'"
          :chart-data="cardConvertidos.series"
        />
      </b-col>
      <b-col
        lg="3"
        sm="6"
      >
        <statistic-card-with-area-chart
          v-if="data.ordersRecevied"
          icon="DollarSignIcon"
          color="success"
          :statistic="kFormatter(cardTotalConvertido.analyticsData.totalConvertidos)"
          statistic-title="Total convertido"
          :chart-data="cardTotalConvertido.series"
        />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        lg="4"
      >
        <chartjs-polar-area-chart
          v-if="chartData.data.labels.length > 0"
          :chart-data="chartData"
        />
      </b-col>
      <b-col
        sm="8"
        lg="8"
      >
        <b-card
          v-if="congratulations.name"
          title="Conversões por dia"
        >
          <app-echart-stacked-area
            :option-data="option"
          />
        </b-card>
      </b-col>
      <!-- Revenue Report Card -->
      <!-- <b-col sm="8">
        <ecommerce-revenue-report :data="data.revenue" />
      </b-col> -->
      <!--/ Revenue Report Card -->
    </b-row>

    <b-row class="match-height">
      <!-- Company Table Card -->
      <b-col
        lg="8"
        md="6"
      >
        <div>
          <vue-html2pdf
            ref="html2Pdf"
            :show-layout="false"
            :float-layout="false"
            :enable-download="true"
            :preview-modal="false"
            :paginate-elements-by-height="1400"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="landscape"
            pdf-content-width="90%"
            :html-to-pdf-options="htmlToPdfOptions"

            @progress="onProgress($event)"
            @hasStartedGeneration="hasStartedGeneration()"
            @hasGenerated="hasGenerated($event)"
          >

            <section slot="pdf-content">

              <ecommerce-company-table
                :table-data="report"
              />

            </section>
          </vue-html2pdf>
        </div>
      </b-col>

      <!--/ Company Table Card -->

      <!-- Developer Meetup Card -->
      <b-col
        lg="4"
        md="6"
      >
        <b-button
          v-if="chartData.data.labels.length > 0"
          id="getPDF"
          type="reset"
          variant="outline-secondary"
          @click="generateReport()"
        >
          Baixar Relatório em PDF
        </b-button>
        <ecommerce-meetup :data="data.meetup" />
      </b-col>
      <!--/ Developer Meetup Card -->
    </b-row>

    <b-row>
      <b-col cols="12">
        <invoice-list
          v-if="listAttendings.length != 0"
          :attendigs="listAttendings"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BButton, BAlert, BCard, BSpinner,
} from 'bootstrap-vue'
import StatisticCardWithAreaChart from '@core/components/statistics-cards/StatisticCardWithAreaChart.vue'
import { kFormatter } from '@core/utils/filter'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import InvoiceList from '@/views/apps/invoice/invoice-list/InvoiceList.vue'
import AppEchartStackedArea from '@core/components/charts/echart/AppEchartStackedArea.vue'
import { $themeColors } from '@themeConfig'
import VueHtml2pdf from 'vue-html2pdf'
import ChartjsPolarAreaChart from '../../charts-and-maps/charts/chartjs/ChartjsPolarAreaChart.vue'
import AnalyticsCongratulation from './AnalyticsCongratulation.vue'
import AnalyticsAvgSessions from './AnalyticsAvgSessions.vue'
//  import AnalyticsSupportTracker from './AnalyticsSupportTracker.vue'
//  import AnalyticsTimeline from './AnalyticsTimeline.vue'
import EcommerceRevenueReport from '../ecommerce/EcommerceRevenueReport.vue'
import EcommerceCompanyTable from '../ecommerce/EcommerceCompanyTable.vue'
import EcommerceMeetup from '../ecommerce/EcommerceMeetup.vue'
import attendents from '../../../functions/basics/attendents'
import stores from '../../../functions/basics/stores'
import { reportTransactions } from '../../../functions/Report/report'
//  npm i --save-dev @types/vue-html2pdf

const chartColors = {
  primaryColorShade: '#836AF9',
  yellowColor: '#ffe800',
  successColorShade: '#28dac6',
  warningColorShade: '#ffe802',
  warningLightColor: '#FDAC34',
  infoColorShade: '#299AFF',
  greyColor: '#4F5D70',
  blueColor: '#2c9aff',
  blueLightColor: '#84D0FF',
  greyLightColor: '#EDF1F4',
  tooltipShadow: 'rgba(0, 0, 0, 0.25)',
  lineChartPrimary: '#666ee8',
  lineChartDanger: '#ff4961',
  labelColor: '#6e6b7b',
  grid_line_color: 'rgba(200, 200, 200, 0.2)',
}
export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BAlert,
    BCard,
    BSpinner,
    AnalyticsCongratulation,
    AnalyticsAvgSessions,
    StatisticCardWithAreaChart,
    InvoiceList,
    EcommerceRevenueReport,
    EcommerceCompanyTable,
    EcommerceMeetup,
    vSelect,
    flatPickr,
    AppEchartStackedArea,
    ChartjsPolarAreaChart,
    VueHtml2pdf,
  },
  data() {
    return {
      htmlToPdfOptions: {
        margin: 0,

        filename: 'manyconvert-relatorio.pdf',

        image: {
          type: 'jpeg',
          quality: 0.98,
        },

        enableLinks: false,

        html2canvas: {
          scale: 1,
          useCORS: false,
        },

        jsPDF: {
          unit: 'in',
          format: 'a4',
          orientation: 'portrait',
        },
      },
      congratulations: {
        name: null,
        totalSale: 0,
      },
      cardConvertidos: {
        series: [
          {
            name: 'Convertidos',
            data: null,
          },
        ],
        analyticsData: {
          convertidos: 0,
          contactados: 0,
        },
      },
      cardTotalConvertido: {
        series: [
          {
            name: 'Convertidos',
            data: [],
          },
        ],
        analyticsData: {
          totalConvertidos: 0,
        },
      },
      listAttendings: [],
      data: {},
      chartData: {
        title: 'Forma de Finalização',
        options: {
          responsive: true,
          maintainAspectRatio: false,
          responsiveAnimationDuration: 500,
          legend: {
            position: 'right',
            labels: {
              usePointStyle: true,
              padding: 25,
              boxWidth: 10,
              fontColor: chartColors.labelColor,
            },
          },
          tooltips: {
            // Updated default tooltip UI
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 8,
            shadowColor: chartColors.tooltipShadow,
            backgroundColor: $themeColors.light,
            titleFontColor: $themeColors.dark,
            bodyFontColor: $themeColors.dark,
          },
          scale: {
            scaleShowLine: true,
            scaleLineWidth: 1,
            ticks: {
              display: false,
              fontColor: chartColors.labelColor,
            },
            reverse: false,
            gridLines: {
              display: false,
            },
          },
          animation: {
            animateRotate: false,
          },
        },
        data: {
          labels: [],
          datasets: [
            {
              label: 'Population (millions)',
              backgroundColor: [
                chartColors.primaryColorShade,
                chartColors.warningColorShade,
                $themeColors.primary,
                chartColors.infoColorShade,
                chartColors.greyColor,
                chartColors.successColorShade,
              ],
              data: [],
              borderWidth: 0,
            },
          ],
        },
      },
      attendent: null,
      option: {
        xAxisData: [],
        series: [
          {
            name: 'Convertidos',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            showSymbol: false,
            lineStyle: {
              width: 0,
            },
            data: [],
          },
          {
            name: 'Contatados',
            type: 'line',
            stack: 'Total',
            showSymbol: false,
            areaStyle: {},
            lineStyle: {
              width: 0,
            },
            data: [],
          },
        ],
      },
      rangeDate: null,
      attendents: [{ id: 0, name: 'todos atendentes' }],
      stores: [],
      store: null,
      showDismissibleAlert: false,
      report: null,
      payment: {
        1: 'Carrinho abandonado', 2: 'Boleto', 3: 'Cartão de Crédito', 4: 'Cartão de Débito', 5: 'Paypal', 6: 'Pix', 7: 'Transferência Bancária', 8: 'Moip', 9: 'Bcash', 10: 'Hotmart', 11: 'Mercado Pago', 12: 'Boleto + Cartão', 13: 'Addi', 14: 'PagaLeve', 15: 'Ame', 16: 'Pix Parcelado', 17: 'Koin', 18: '2 Cartões', 19: '', 20: '', 21: '', 22: '', 23: 'NuPay', 24: 'MarketPlace',
      },
      totalContactados: 0,
      totalConvertidos: 0,
      loading: false,
    }
  },
  async mounted() {
    const attendentsList = await attendents()
    this.attendents.push(...attendentsList)
    this.stores = await stores()
  },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf()
    },
    kFormatter,
    getDataCards() {
      // data
      this.$http.get('/analytics/data')
        .then(response => { console.log(response.data); this.data = response.data })
    },
    async getReport() {
      if (!(this.attendent && this.store && this.rangeDate)) {
        this.showDismissibleAlert = !this.showDismissibleAlert
      } else {
        const button = document.querySelector('#getReport')
        button.disabled = true
        this.showDismissibleAlert = false
        // Limpar os campos
        this.report = null
        this.option.xAxisData.length = 0
        this.option.series[0].data.length = 0
        this.option.series[1].data.length = 0
        this.chartData.data.labels.length = 0
        this.chartData.data.datasets[0].data.length = 0
        this.cardConvertidos.analyticsData.convertidos = 0
        this.cardConvertidos.analyticsData.contactados = 0
        this.cardTotalConvertido.analyticsData.totalConvertidos = 0
        this.listAttendings.length = 0
        this.totalContactados = 0
        this.totalConvertidos = 0
        // fim da limpeza

        // formatar data
        const dataRange = this.rangeDate.replace(' ', '').split('to')
        this.loading = true
        // buscar informações para dashboard
        const reportList = await reportTransactions(this.attendent.id, this.store.id, dataRange[0], dataRange[1], 2).finally(() => { button.disabled = false })

        // Card Congratulations
        this.congratulations.name = this.attendent.name

        // Criar variaveis
        const data = []

        const geral = []

        const reportData = []

        for (let i = 1; i <= 24; i++) {
          data[i] = {}
          data[i].convertidos = {}
          data[i].contactados = 0
          data[i].TotalConvertidos = 0
          data[i].ValorTotalContatados = 0

          geral[i] = {}
          geral[i].convertidos = 0
          geral[i].total = 0

          for (let j = 1; j <= 24; j++) {
            data[i].convertidos[j] = []
            data[i].convertidos[j].qtd = 0
            data[i].convertidos[j].total = 0
          }
        }

        // formatar dados
        await reportList.attendings.forEach(element => {
          console.log(element)
          // contactados por tipo de pagamento
          data[element.first_transaction.payment_id].contactados += 1

          if (element.last_transaction) {
            // numero de após primeiro contato
            data[element.first_transaction.payment_id].TotalConvertidos += 1
            // Valor convertido
            data[element.first_transaction.payment_id].ValorTotalContatados += parseFloat(element.last_transaction.amount)

            // Quantidade e total por tipo de pagamento de finalização após o primeiro contato. Ex: Boleto finalizado no cartão
            data[element.first_transaction.payment_id].convertidos[element.last_transaction.payment_id].qtd += 1
            data[element.first_transaction.payment_id].convertidos[element.last_transaction.payment_id].total += parseFloat(element.last_transaction.amount)

            geral[element.last_transaction.payment_id].total += parseFloat(element.last_transaction.amount)
            geral[element.last_transaction.payment_id].convertidos += 1
          }
        })

        // Tabela
        await data.forEach((value, key) => {
          if (value.contactados !== 0) {
            const porcent = ((value.TotalConvertidos * 100) / value.contactados)
            const { ValorTotalContatados } = value

            reportData.push({
              FormaPagamento: this.payment[key], contactados: value.contactados, convertidos: value.TotalConvertidos, total: ValorTotalContatados.toLocaleString('pt-br', { minimumFractionDigits: 2 }), porcent: parseFloat(porcent.toFixed(2)),
            })

            this.cardTotalConvertido.analyticsData.totalConvertidos += parseFloat(ValorTotalContatados.toFixed(2))

            this.totalContactados += value.contactados
            this.totalConvertidos += value.TotalConvertidos
          }
        })

        this.report = reportData

        console.log('AQUI', this.report)

        const porcentConvertion = (this.totalConvertidos * 100) / this.totalContactados
        this.congratulations.totalSale = parseFloat(porcentConvertion.toFixed(2))
        const testess = this.cardTotalConvertido.analyticsData.totalConvertidos
        const f = testess.toLocaleString('pt-br', { minimumFractionDigits: 2 })
        reportData.push({
          FormaPagamento: 'Total', contactados: this.totalContactados, convertidos: this.totalConvertidos, total: f, porcent: parseFloat(porcentConvertion.toFixed(2)),
        })

        // Contatados por data
        reportList.attendingsDate.forEach(element => {
          this.option.xAxisData.push(element.date)
          this.option.series[1].data.push(element['count(*)'])
          this.cardConvertidos.analyticsData.contactados += element['count(*)']
        })

        // Convertidos por data
        reportList.attendingsDateStatus.forEach(element => {
          this.option.series[0].data.push(element['count(*)'])
          this.cardConvertidos.analyticsData.convertidos += element['count(*)']
        })

        await geral.forEach((value, key) => {
          if (value.convertidos !== 0) {
            const type = this.payment[key]
            this.chartData.data.labels.push(type)
            this.chartData.data.datasets[0].data.push(value.convertidos)
          }
        })

        this.cardConvertidos.series[0].data = this.option.series[1].data

        this.listAttendings = reportList.attendings

        this.getDataCards()
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
